import { type NavigationGuard } from 'vue-router';
import { useAuthStore } from '@/stores/auth';

export const redirectToHomeIfNoRangesAccess: NavigationGuard = async (to, from, next) => {
  const authStore = useAuthStore();

  if (authStore.appAccess.nav.ranges) {
    return next();
  } else {
    return next({ name: 'home' });
  }
};
